// Frontend mirror of pocketbase/hooks/madrid-date.js. Browsers have a
// reliable Intl, but for parity with the backend we apply the same EU
// DST rule (last Sunday of March/October at 01:00 UTC) so a day named
// "YYYY-MM-DD" always means the same calendar day on both ends of the
// stack. Used everywhere the user-facing UI computes "today / this
// week / this month".

function lastSundayUtc(year: number, monthIdx: number): Date {
  const d = new Date(Date.UTC(year, monthIdx + 1, 0));
  while (d.getUTCDay() !== 0) d.setUTCDate(d.getUTCDate() - 1);
  return d;
}

function isMadridDST(d: Date): boolean {
  const year = d.getUTCFullYear();
  const dstStart = lastSundayUtc(year, 2);
  dstStart.setUTCHours(1, 0, 0, 0);
  const dstEnd = lastSundayUtc(year, 9);
  dstEnd.setUTCHours(1, 0, 0, 0);
  return d >= dstStart && d < dstEnd;
}

function offsetMs(d: Date): number {
  return (isMadridDST(d) ? 2 : 1) * 3600 * 1000;
}

export function madridDateOf(d: Date): string {
  const shifted = new Date(d.getTime() + offsetMs(d));
  return shifted.toISOString().slice(0, 10);
}

export function madridToday(): string {
  return madridDateOf(new Date());
}

export function madridStartOfDay(dateStr: string): Date {
  const noonUtc = new Date(dateStr + 'T12:00:00.000Z');
  const off = offsetMs(noonUtc);
  const midUtc = new Date(dateStr + 'T00:00:00.000Z');
  return new Date(midUtc.getTime() - off);
}

export function madridDateAddDays(dateStr: string, n: number): string {
  const start = madridStartOfDay(dateStr);
  return madridDateOf(new Date(start.getTime() + n * 86400000));
}

function dateStrWeekday(dateStr: string): number {
  return new Date(dateStr + 'T00:00:00.000Z').getUTCDay();
}

export function madridMonday(dateStr: string = madridToday()): string {
  const day = dateStrWeekday(dateStr);
  const diff = day === 0 ? -6 : 1 - day;
  return madridDateAddDays(dateStr, diff);
}

export function madridFirstOfMonth(dateStr: string = madridToday()): string {
  return dateStr.slice(0, 7) + '-01';
}
